// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gaia__container {
    cursor: default;
}

.gaia__map__container {
    display: flex;
}

.gaia__map {
    height: 500px;
    flex: 1;
}

.gaia__container:fullscreen {
    background-color: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.gaia__container:fullscreen .gaia__map__container {
    flex: 1;
    height: calc(100vh - 60px);
}

.gaia__container:fullscreen .gaia__map {
    height: 100%;
}

.gaia__container:-webkit-full-screen {
    background-color: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.gaia__container:-webkit-full-screen .gaia__map__container {
    flex: 1;
    height: calc(100vh - 60px);
}

.gaia__container:-webkit-full-screen .gaia__map {
    height: 100%;
}

.gaia__container:-moz-full-screen {
    background-color: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.gaia__container:-moz-full-screen .gaia__map__container {
    flex: 1;
    height: calc(100vh - 60px);
}

.gaia__container:-moz-full-screen .gaia__map {
    height: 100%;
}

.gaia__container:-ms-fullscreen {
    background-color: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.gaia__container:-ms-fullscreen .gaia__map__container {
    flex: 1;
    height: calc(100vh - 60px);
}

.gaia__container:-ms-fullscreen .gaia__map {
    height: 100%;
}

.leaflet-bar button {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 10px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
}

.leaflet-bar button:hover {
    background-color: #f0f0f0;
}

.leaflet-bar button.selected {
    border: 2px solid #0357a6;
}

.gaia-draw-button {
    background: transparent;
    border: none;
    padding: 8px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    transition: background-color 0.2s;
}

.gaia-draw-control {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s, border-color 0.2s;
    cursor: pointer;
}

.gaia-draw-control:hover {
    background-color: rgba(0, 0, 0, 0.08);
}

.gaia-draw-control.selected {
    background-color: rgba(0, 0, 0, 0.08);
}

.gaia-draw-control.disabled {
    opacity: 0.5;
    pointer-events: none;
}

.gaia-selection-boundary {
    border: 2px solid blue;
    background-color: rgba(211, 211, 211, 0.4);
    border-radius: 0;
}

.gaia-selected-polygon {
    border: 2px solid blue !important;
    background-color: rgba(211, 211, 211, 0.3) !important;
    stroke-dasharray: none !important;
}

.first-vertex-marker {
    cursor: pointer !important;
}

.first-vertex-marker svg,
.first-vertex-marker circle {
    z-index: 1001 !important;
    pointer-events: auto !important;
}

.first-vertex-marker:hover circle {
    fill: #f8f8f8 !important;
    stroke-width: 3px !important;
}

.first-vertex-marker.pulsing-vertex circle {
    animation: pulse-vertex 1.5s infinite;
}

@keyframes pulse-vertex {
    0% {
        stroke-width: 2px;
        stroke-opacity: 1;
    }
    50% {
        stroke-width: 4px;
        stroke-opacity: 0.8;
    }
    100% {
        stroke-width: 2px;
        stroke-opacity: 1;
    }
}

/* Print Preview Styles */
.print-preview-controls {
    z-index: 1000 !important;
    pointer-events: auto !important;
    position: absolute !important;
    background: white !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.print-preview-overlay {
    pointer-events: none !important;
    z-index: 999 !important;
}

.drawing-polygon {
    pointer-events: none !important;
}

.leaflet-interactive.temp-drawing {
    pointer-events: none !important;
}

/* Ensure marker pane has proper z-index and pointer events */
.leaflet-marker-pane {
    z-index: 600 !important;
    pointer-events: auto !important;
}

.leaflet-marker-icon {
    pointer-events: auto !important;
    cursor: pointer !important;
}

.leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: 15px;
    overflow: hidden;
}

.leaflet-popup-content {
    margin: 0;
    line-height: 1.4;
}

.marker-popup-content {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: 0.2rem;
    font-size: 14px;
    font-family: inherit;
    box-sizing: border-box;
}

.marker-popup-content::-webkit-scrollbar {
    width: 4px;
}

.marker-popup-content::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2px;
}

.marker-popup-content::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
}

.marker-popup-content::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}

.marker-popup-content::-webkit-scrollbar-button {
    display: none;
}

.marker-popup-content {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.neighbourMarkerPopupCard__content {
    padding: 8px !important;
}

.leaflet-container {
    font-family: inherit;
}

.ruler-tooltip {
    background-color: white;
    border: 1px solid #ccc;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    white-space: nowrap;
    pointer-events: auto !important;
    z-index: 1000 !important;
}

.ruler-tooltip::before,
.ruler-polygon-tooltip::before {
    display: none;
}

.inspection-tooltip {
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0;
    margin: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    pointer-events: auto !important;
    z-index: 1000 !important;
}

.inspection-tooltip::before {
    border-color: transparent;
    border-right-color: white;
}

.inspection-tooltip::after {
    border-color: transparent;
    border-right-color: white;
}

.leaflet-tooltip-left.inspection-tooltip::before {
    border-color: transparent;
    border-left-color: white;
    transform: translateY(var(--arrow-offset, 0px));
}

.leaflet-tooltip-left.inspection-tooltip::after {
    border-color: transparent;
    border-left-color: white;
    transform: translateY(var(--arrow-offset, 0px));
}

.leaflet-tooltip-right.inspection-tooltip::before {
    border-color: transparent;
    border-right-color: white;
    transform: translateY(var(--arrow-offset, 0px));
}

.leaflet-tooltip-right.inspection-tooltip::after {
    border-color: transparent;
    border-right-color: white;
    transform: translateY(var(--arrow-offset, 0px));
}

.leaflet-tooltip-top.inspection-tooltip::before {
    border-color: transparent;
    border-top-color: white;
}

.leaflet-tooltip-top.inspection-tooltip::after {
    border-color: transparent;
    border-top-color: white;
}

.leaflet-tooltip-bottom.inspection-tooltip::before {
    border-color: transparent;
    border-bottom-color: white;
}

.leaflet-tooltip-bottom.inspection-tooltip::after {
    border-color: transparent;
    border-bottom-color: white;
}

.ruler-polygon-tooltip {
    background-color: white;
    border: 1px solid #ccc;
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    pointer-events: auto !important;
    z-index: 1000 !important;
    min-width: 120px;
}

.ruler-tooltip-content,
.inspection-tooltip-content {
    pointer-events: auto !important;
    z-index: 1001 !important;
    display: flex;
    align-items: center;
    gap: 8px;
}

.ruler-delete-button {
    opacity: 0.6;
    transition: opacity 0.2s;
    cursor: pointer !important;
    padding: 2px !important;
    margin-left: 4px;
    border-radius: 2px;
}

.ruler-delete-button:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.05) !important;
}

.ruler-line {
    cursor: pointer;
}

.ruler-polygon {
    cursor: pointer;
}

@keyframes ruler-vertex-pulse {
    0% {
        r: 7;
        stroke-opacity: 1;
    }
    50% {
        r: 9;
        stroke-opacity: 0.7;
    }
    100% {
        r: 7;
        stroke-opacity: 1;
    }
}

/* Marker with badge styling */
.marker-with-badge {
    position: relative;
}

.marker-with-badge .leaflet-marker-icon {
    width: 25px;
    height: 41px;
}

.marker-with-badge .leaflet-marker-shadow {
    width: 41px;
    height: 41px;
    position: absolute;
    left: -1px;
    top: 0;
    z-index: -1;
}

.marker-badge {
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: #0357a6;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    border: 2px solid white;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    pointer-events: none;
}

.default-marker-icon {
    width: 25px;
    height: 41px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
}

/* Center marker styling */
.center-marker {
    z-index: 1000;
}

/* Non-interactive marker styling */
.non-interactive-marker {
    pointer-events: none !important;
    cursor: default !important;
}

/* Edit vertex styling */
.edit-vertex-main {
    cursor: move !important;
    z-index: 1000 !important;
    pointer-events: auto !important;
}

.edit-vertex-main:hover circle {
    fill: #2166ff !important;
    r: 9 !important;
}

.edit-vertex-mid {
    cursor: pointer !important;
    z-index: 999 !important;
    pointer-events: auto !important;
}

.edit-vertex-mid:hover circle {
    fill: #666 !important;
    r: 6 !important;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/gaiaMap/GaiaMap.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,OAAO;IACP,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,qDAAqD;IACrD,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;;AAEA,yBAAyB;AACzB;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;AACxD;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,6DAA6D;AAC7D;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,mBAAmB;IACnB,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,wCAAwC;IACxC,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,+BAA+B;IAC/B,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;IAC/B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,IAAI;QACJ,iBAAiB;IACrB;IACA;QACI,IAAI;QACJ,mBAAmB;IACvB;IACA;QACI,IAAI;QACJ,iBAAiB;IACrB;AACJ;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAm9D;IACn9D,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA,0BAA0B;AAC1B;IACI,aAAa;AACjB;;AAEA,mCAAmC;AACnC;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":[".gaia__container {\n    cursor: default;\n}\n\n.gaia__map__container {\n    display: flex;\n}\n\n.gaia__map {\n    height: 500px;\n    flex: 1;\n}\n\n.gaia__container:fullscreen {\n    background-color: white;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.gaia__container:fullscreen .gaia__map__container {\n    flex: 1;\n    height: calc(100vh - 60px);\n}\n\n.gaia__container:fullscreen .gaia__map {\n    height: 100%;\n}\n\n.gaia__container:-webkit-full-screen {\n    background-color: white;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.gaia__container:-webkit-full-screen .gaia__map__container {\n    flex: 1;\n    height: calc(100vh - 60px);\n}\n\n.gaia__container:-webkit-full-screen .gaia__map {\n    height: 100%;\n}\n\n.gaia__container:-moz-full-screen {\n    background-color: white;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.gaia__container:-moz-full-screen .gaia__map__container {\n    flex: 1;\n    height: calc(100vh - 60px);\n}\n\n.gaia__container:-moz-full-screen .gaia__map {\n    height: 100%;\n}\n\n.gaia__container:-ms-fullscreen {\n    background-color: white;\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.gaia__container:-ms-fullscreen .gaia__map__container {\n    flex: 1;\n    height: calc(100vh - 60px);\n}\n\n.gaia__container:-ms-fullscreen .gaia__map {\n    height: 100%;\n}\n\n.leaflet-bar button {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    padding: 10px;\n    cursor: pointer;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n}\n\n.leaflet-bar button:hover {\n    background-color: #f0f0f0;\n}\n\n.leaflet-bar button.selected {\n    border: 2px solid #0357a6;\n}\n\n.gaia-draw-button {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    transition: background-color 0.2s;\n}\n\n.gaia-draw-control {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 4px;\n    border-radius: 4px;\n    transition: background-color 0.2s, border-color 0.2s;\n    cursor: pointer;\n}\n\n.gaia-draw-control:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.gaia-draw-control.selected {\n    background-color: rgba(0, 0, 0, 0.08);\n}\n\n.gaia-draw-control.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.gaia-selection-boundary {\n    border: 2px solid blue;\n    background-color: rgba(211, 211, 211, 0.4);\n    border-radius: 0;\n}\n\n.gaia-selected-polygon {\n    border: 2px solid blue !important;\n    background-color: rgba(211, 211, 211, 0.3) !important;\n    stroke-dasharray: none !important;\n}\n\n.first-vertex-marker {\n    cursor: pointer !important;\n}\n\n.first-vertex-marker svg,\n.first-vertex-marker circle {\n    z-index: 1001 !important;\n    pointer-events: auto !important;\n}\n\n.first-vertex-marker:hover circle {\n    fill: #f8f8f8 !important;\n    stroke-width: 3px !important;\n}\n\n.first-vertex-marker.pulsing-vertex circle {\n    animation: pulse-vertex 1.5s infinite;\n}\n\n@keyframes pulse-vertex {\n    0% {\n        stroke-width: 2px;\n        stroke-opacity: 1;\n    }\n    50% {\n        stroke-width: 4px;\n        stroke-opacity: 0.8;\n    }\n    100% {\n        stroke-width: 2px;\n        stroke-opacity: 1;\n    }\n}\n\n/* Print Preview Styles */\n.print-preview-controls {\n    z-index: 1000 !important;\n    pointer-events: auto !important;\n    position: absolute !important;\n    background: white !important;\n    border-radius: 4px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;\n}\n\n.print-preview-overlay {\n    pointer-events: none !important;\n    z-index: 999 !important;\n}\n\n.drawing-polygon {\n    pointer-events: none !important;\n}\n\n.leaflet-interactive.temp-drawing {\n    pointer-events: none !important;\n}\n\n/* Ensure marker pane has proper z-index and pointer events */\n.leaflet-marker-pane {\n    z-index: 600 !important;\n    pointer-events: auto !important;\n}\n\n.leaflet-marker-icon {\n    pointer-events: auto !important;\n    cursor: pointer !important;\n}\n\n.leaflet-popup-content-wrapper {\n    padding: 0;\n    border-radius: 15px;\n    overflow: hidden;\n}\n\n.leaflet-popup-content {\n    margin: 0;\n    line-height: 1.4;\n}\n\n.marker-popup-content {\n    max-height: 400px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    padding: 0.2rem;\n    font-size: 14px;\n    font-family: inherit;\n    box-sizing: border-box;\n}\n\n.marker-popup-content::-webkit-scrollbar {\n    width: 4px;\n}\n\n.marker-popup-content::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 2px;\n}\n\n.marker-popup-content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n}\n\n.marker-popup-content::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.marker-popup-content::-webkit-scrollbar-button {\n    display: none;\n}\n\n.marker-popup-content {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n\n.neighbourMarkerPopupCard__content {\n    padding: 8px !important;\n}\n\n.leaflet-container {\n    font-family: inherit;\n}\n\n.ruler-tooltip {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    white-space: nowrap;\n    pointer-events: auto !important;\n    z-index: 1000 !important;\n}\n\n.ruler-tooltip::before,\n.ruler-polygon-tooltip::before {\n    display: none;\n}\n\n.inspection-tooltip {\n    background: white;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 0;\n    margin: 0;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    pointer-events: auto !important;\n    z-index: 1000 !important;\n}\n\n.inspection-tooltip::before {\n    border-color: transparent;\n    border-right-color: white;\n}\n\n.inspection-tooltip::after {\n    border-color: transparent;\n    border-right-color: white;\n}\n\n.leaflet-tooltip-left.inspection-tooltip::before {\n    border-color: transparent;\n    border-left-color: white;\n    transform: translateY(var(--arrow-offset, 0px));\n}\n\n.leaflet-tooltip-left.inspection-tooltip::after {\n    border-color: transparent;\n    border-left-color: white;\n    transform: translateY(var(--arrow-offset, 0px));\n}\n\n.leaflet-tooltip-right.inspection-tooltip::before {\n    border-color: transparent;\n    border-right-color: white;\n    transform: translateY(var(--arrow-offset, 0px));\n}\n\n.leaflet-tooltip-right.inspection-tooltip::after {\n    border-color: transparent;\n    border-right-color: white;\n    transform: translateY(var(--arrow-offset, 0px));\n}\n\n.leaflet-tooltip-top.inspection-tooltip::before {\n    border-color: transparent;\n    border-top-color: white;\n}\n\n.leaflet-tooltip-top.inspection-tooltip::after {\n    border-color: transparent;\n    border-top-color: white;\n}\n\n.leaflet-tooltip-bottom.inspection-tooltip::before {\n    border-color: transparent;\n    border-bottom-color: white;\n}\n\n.leaflet-tooltip-bottom.inspection-tooltip::after {\n    border-color: transparent;\n    border-bottom-color: white;\n}\n\n.ruler-polygon-tooltip {\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 6px 10px;\n    border-radius: 4px;\n    font-size: 12px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    pointer-events: auto !important;\n    z-index: 1000 !important;\n    min-width: 120px;\n}\n\n.ruler-tooltip-content,\n.inspection-tooltip-content {\n    pointer-events: auto !important;\n    z-index: 1001 !important;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.ruler-delete-button {\n    opacity: 0.6;\n    transition: opacity 0.2s;\n    cursor: pointer !important;\n    padding: 2px !important;\n    margin-left: 4px;\n    border-radius: 2px;\n}\n\n.ruler-delete-button:hover {\n    opacity: 1;\n    background-color: rgba(0, 0, 0, 0.05) !important;\n}\n\n.ruler-line {\n    cursor: pointer;\n}\n\n.ruler-polygon {\n    cursor: pointer;\n}\n\n@keyframes ruler-vertex-pulse {\n    0% {\n        r: 7;\n        stroke-opacity: 1;\n    }\n    50% {\n        r: 9;\n        stroke-opacity: 0.7;\n    }\n    100% {\n        r: 7;\n        stroke-opacity: 1;\n    }\n}\n\n/* Marker with badge styling */\n.marker-with-badge {\n    position: relative;\n}\n\n.marker-with-badge .leaflet-marker-icon {\n    width: 25px;\n    height: 41px;\n}\n\n.marker-with-badge .leaflet-marker-shadow {\n    width: 41px;\n    height: 41px;\n    position: absolute;\n    left: -1px;\n    top: 0;\n    z-index: -1;\n}\n\n.marker-badge {\n    position: absolute;\n    top: -5px;\n    right: -10px;\n    background-color: #0357a6;\n    color: white;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: bold;\n    border: 2px solid white;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n    pointer-events: none;\n}\n\n.default-marker-icon {\n    width: 25px;\n    height: 41px;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=\");\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n/* Center marker styling */\n.center-marker {\n    z-index: 1000;\n}\n\n/* Non-interactive marker styling */\n.non-interactive-marker {\n    pointer-events: none !important;\n    cursor: default !important;\n}\n\n/* Edit vertex styling */\n.edit-vertex-main {\n    cursor: move !important;\n    z-index: 1000 !important;\n    pointer-events: auto !important;\n}\n\n.edit-vertex-main:hover circle {\n    fill: #2166ff !important;\n    r: 9 !important;\n}\n\n.edit-vertex-mid {\n    cursor: pointer !important;\n    z-index: 999 !important;\n    pointer-events: auto !important;\n}\n\n.edit-vertex-mid:hover circle {\n    fill: #666 !important;\n    r: 6 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
